module.exports = __webpack_public_path__ + "static/media/chin-post.59f55228.png";